<ui-bottom-sheet
  [open]="open()"
  [title]="title()"
  [description]="description()"
  [closeLabel]="closeLabel()"
  (closed)="handleClosed()"
>
  <div
    class="ui-confirm-sheet-actions"
    [class.ui-confirm-sheet-actions-destructive]="isDestructive()"
  >
    <ui-button [fullWidth]="true" size="lg" (pressed)="handleConfirmed()">
      {{ primaryLabel() }}
    </ui-button>
    <ui-button
      [fullWidth]="true"
      size="lg"
      variant="secondary"
      (pressed)="handleCancelled()"
    >
      {{ cancelLabel() }}
    </ui-button>
  </div>
</ui-bottom-sheet>
